import { useMemo } from 'react'

import { calculateCreditDays } from '../AddCostMetrics/AddCostMetrics'
import { Table } from '@baseV2'
import { displayAmount } from '@utils'
import { PaddedWrapper } from './styles'

const MetricsData = ({ totalPoAmount, pastDelays, totalDays, paymentTermsList = [], supplierList }) => {
	const columns = [
		{ label: 'Name', key: 'heading', mobile: true, align: 'left' },
		{ label: 'Value', key: 'value', mobile: true, align: 'left' },
	]
	const formatDays = (val) => (val == null || Number.isNaN(val) ? '-' : `${val} Days`)

	const tableData = useMemo(() => {
		let _data = []
		let _pastDelays = parseInt(pastDelays)
		let creditDays = calculateCreditDays(paymentTermsList)
		let orderGivenSupplierDays = supplierList
			?.filter((_i) => _i?.order_given === true)
			?.reduce((acc, item) => (acc = Math.max(item?.expected_transit_time, acc)), 0)
		if (orderGivenSupplierDays === 0) {
			orderGivenSupplierDays = supplierList
				?.filter((_i) => _i?.expected_transit_time)
				.reduce((acc, item) => (acc = Math.max(item?.expected_transit_time, acc)), 0)
		}
		supplierList?.map((item, index) => {
			_data.push({
				heading: `Transit time (${item?.supplier?.organisation_name ?? item?.supplier?.full_name})`,
				value: formatDays(item?.expected_transit_time),
			})
		})
		_data.push(
			{ heading: 'Credit Days', value: formatDays(creditDays) },
			{ heading: 'Past Delays', value: formatDays(pastDelays == null ? null : _pastDelays) },
			{
				heading: 'Total Days',
				value: formatDays(totalDays == null && orderGivenSupplierDays == null ? null : (totalDays ?? 0) + (orderGivenSupplierDays ?? 0)),
			},
			{ heading: 'PO Amount', value: totalPoAmount == null ? '-' : displayAmount(totalPoAmount) }
		)
		return _data
	}, [totalDays, totalPoAmount, paymentTermsList, pastDelays, supplierList])

	return (
		<PaddedWrapper>
			<Table columns={columns} data={tableData} totalItemCount={tableData.length} rowClickable={false} rowsToDisplay={tableData.length} hideFooter />
		</PaddedWrapper>
	)
}

export default MetricsData
